import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CatalogConfig } from '@app/shared/model/interfaces/catalog';

@Component({
  selector: 'vc-catalog-action-bar',
  templateUrl: './catalog-action-bar.component.html',
  styleUrls: ['./catalog-action-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogActionBarComponent {
  @Input()
  isMobile: boolean;
  @Input()
  configCatalog: CatalogConfig;
  @Input()
  hasSort: boolean;
  @Output()
  change = new EventEmitter<'alert' | 'sort' | 'filters'>();

  public alertsEnabled = false;

  emitAction(action) {
    this.change.emit(action);
  }
}
